<div
  [attr.data-cy-specific-window-name]="name"
  [ngClass]="[!isModal ? 'iu-specific-window-container' : '', 'iu-specific-window']">
  @if (!isModal && isLoading) {
    <p-progressBar [mode]="'indeterminate'" [showValue]="false" [styleClass]="'loading-progressbar'" [value]="0" />
  }

  <p-scrollPanel [style]="{ width: '100%', height: '100%' }">
    <div class="fields">
      <div class="top-container-AccountEditor">
        <div class="p-col-12 p-grid"><ng-template #top /></div>
        <div hidden="true"><ng-template #hidden /></div>
      </div>
      <div class="p-col-4 apiz-p-grid"><ng-template #left /></div>
      <div class="bot-container-AccountEditor">
        <div class="p-col-12"><ng-template #bot /></div>
      </div>
    </div>

    <div class="iu-specific-btn-container" [ngClass]="[shouldAddPadding ? 'shouldAddPadding' : '']">
      <ng-template #vcrButtons />

      <iu-button-ui
        class="p-col-12 p-md-3 p-lg-1"
        label="{{ 'infodialog.ok' | translate }}"
        (click)="$event.preventDefault(); $event.stopPropagation(); selectCombination(); closeModalEmitter.emit()" />
      @if (isModal) {
        <iu-button-ui
          btnType="alert"
          class="p-col-12 p-md-3 p-lg-1"
          icon="fa fa-ban"
          label="{{ 'process.cancel' | translate }}"
          (click)="$event.preventDefault(); $event.stopPropagation(); closeModalEmitter.emit()" />
      }
    </div>
  </p-scrollPanel>
</div>

<div [ngClass]="[!displayFormUI ? 'hidden' : '', 'specificModal']">
  <iu-modal-ui
    [angularStyle]="customFormModalBodyCss"
    [isModalDisplay]="displayFormUI"
    [title]="specificWindowTitle"
    (closeModalEmitter)="updateModalDisplay({ display: { key: 'displayFormUI', value: false, sourceComponent: this }})">
    <ng-template #vcrSpecific />
  </iu-modal-ui>
</div>
